<template>

    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Invoice</h4>
            <ul class="app-timeline" style="max-height: 300px;overflow: auto;">
                <li  class="timeline-item timeline-variant-primary mb-1" v-for="invoice in billingStore.invoices ">
                    <div  class="timeline-item-point"></div>
                    <div
                        class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                        <h6 >Invoice Number <span class="text-success">#{{invoice.number}}</span></h6>
                        <span class="badge badge-success badge-lg mr-0 mb-0" v-if="invoice.status">{{invoice.status.toUpperCase()}}</span>
                        <span class="badge badge-light badge-lg mr-0 mb-0" v-else>{{invoice.status.toUpperCase()}}</span>
                    </div>
                    <p >{{ formatDate(invoice.period_start, 'lll', isUnix = true)}}</p>
                    <p  class="mb-0 d-flex  flex-sm-row flex-column flex-wrap justify-content-between">
                        <p > {{ formatNumber(invoice.total) }} </p>
                        <div class="d-flex align-items-center">
                            <vue-feather
                                type="download"
                                class="text-success"
                                style="height:20px"
                            ></vue-feather>
                            <a :href="getRoute('billing-subscriptions-invoice', { id: invoice.id })" class="align-bottom">Download Invoice</a>
                        </div>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import {useBillingStore} from '../../stores/BillingStore';
import { getRoute, formatDate } from '../../utilities/_helpers'

export default {
    setup(){
       const billingStore = useBillingStore();
       function formatNumber($value){
            let format = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            return format.format(parseFloat($value)/100);
        }
       return{
            billingStore,
            formatNumber,
            formatDate: formatDate,
            getRoute: getRoute,
       }
    },
    beforeMount(){
        this.billingStore.getInvoice()
    },
    method:{

    }
}
</script>
